import { defineMessages } from 'react-intl';

export default defineMessages({
    preferredPhoneNumber: {
        id: 'ml.quoteandbind.common.PhoneNumberComponent.Preferred Phone Number',
        defaultMessage: 'Preferred Phone Number'
    },
    phoneNumber: {
        id: 'ml.quoteandbind.common.PhoneNumberComponent.Phone Number',
        defaultMessage: 'Phone Number'
    },
    incompleteInput: {
        id: 'ml.quoteandbind.common.PhoneNumberComponent.Enter a 10 digit phone number without dashes',
        defaultMessage: 'Enter a 10 digit phone number without dashes'
    }
});
